export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
    { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
    { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    JSON: unknown;
};

export type AbTest = {
    __typename?: 'ABTest';
    id: Scalars['String'];
    name: Scalars['String'];
};

export type AdditionalLink = {
    __typename?: 'AdditionalLink';
    href?: Maybe<Scalars['String']>;
    label?: Maybe<Scalars['String']>;
};

export type Address = {
    __typename?: 'Address';
    uprn: Scalars['String'];
    usrn?: Maybe<Scalars['String']>;
    latitude?: Maybe<Scalars['Float']>;
    longitude?: Maybe<Scalars['Float']>;
    subBuildingName?: Maybe<Scalars['String']>;
    buildingName?: Maybe<Scalars['String']>;
    number?: Maybe<Scalars['String']>;
    ddLocalityName?: Maybe<Scalars['String']>;
    dependentLocality?: Maybe<Scalars['String']>;
    localityName?: Maybe<Scalars['String']>;
    postTownName?: Maybe<Scalars['String']>;
    postcode: Scalars['String'];
    outcode?: Maybe<Scalars['String']>;
    incode?: Maybe<Scalars['String']>;
    sector?: Maybe<Scalars['String']>;
    postcodeSector?: Maybe<Scalars['String']>;
    postalArea?: Maybe<Scalars['String']>;
    outcodeComp?: Maybe<Scalars['String']>;
    streetName?: Maybe<Scalars['String']>;
    townName?: Maybe<Scalars['String']>;
    administrativeArea?: Maybe<Scalars['String']>;
    country?: Maybe<Scalars['String']>;
    streetAddress: Scalars['String'];
    fullAddress: Scalars['String'];
};

export type AddressesByPostcode = {
    __typename?: 'AddressesByPostcode';
    postcode: Scalars['String'];
    addresses: Array<Maybe<Address>>;
};

export type AddressPostcodeSuggestion = {
    __typename?: 'AddressPostcodeSuggestion';
    g?: Maybe<Array<Maybe<SuggestedAddresses>>>;
    p?: Maybe<Array<Maybe<PastSuggestedAddresses>>>;
};

export type AddressSearchApi = {
    __typename?: 'AddressSearchAPI';
    addressesByPostcode: AddressesByPostcode;
};

export type AdTargeting = {
    __typename?: 'AdTargeting';
    activity?: Maybe<Scalars['String']>;
    areaName?: Maybe<Scalars['String']>;
    brand?: Maybe<Scalars['String']>;
    brandPrimary?: Maybe<Scalars['String']>;
    countryCode?: Maybe<Scalars['String']>;
    currencyCode?: Maybe<Scalars['String']>;
    listingsCategory?: Maybe<Scalars['String']>;
    outcode?: Maybe<Scalars['String']>;
    outcodes?: Maybe<Array<Maybe<Scalars['String']>>>;
    page?: Maybe<Scalars['String']>;
    postalArea?: Maybe<Scalars['String']>;
    priceMax?: Maybe<Scalars['String']>;
    priceMin?: Maybe<Scalars['String']>;
    regionName?: Maybe<Scalars['String']>;
    resultsSort?: Maybe<Scalars['String']>;
    searchLocation?: Maybe<Scalars['String']>;
    searchResultsCount?: Maybe<Scalars['Int']>;
    section?: Maybe<Scalars['String']>;
    totalResults?: Maybe<Scalars['Int']>;
    totalResultsWasLimited?: Maybe<Scalars['Boolean']>;
    url?: Maybe<Scalars['String']>;
    viewType?: Maybe<Scalars['String']>;
    countyAreaName?: Maybe<Scalars['String']>;
    bedsMax?: Maybe<Scalars['String']>;
    bedsMin?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
};

export type AgentBranch = {
    __typename?: 'AgentBranch';
    address?: Maybe<Scalars['String']>;
    branchDetailsUri?: Maybe<Scalars['String']>;
    branchId: Scalars['ID'];
    branchResultsUri?: Maybe<Scalars['String']>;
    logoUrl?: Maybe<Scalars['String']>;
    memberType: MemberType;
    name: Scalars['String'];
    phone?: Maybe<Scalars['String']>;
    postcode?: Maybe<Scalars['String']>;
    attributes: BranchAttributes;
};

export type AlertFrequencyOption = {
    __typename?: 'AlertFrequencyOption';
    i18NLabelKey?: Maybe<Scalars['String']>;
    value?: Maybe<Scalars['String']>;
};

export type AnalyticsEcommerce = {
    __typename?: 'AnalyticsEcommerce';
    currencyCode?: Maybe<Scalars['String']>;
    event?: Maybe<Scalars['String']>;
    impressions?: Maybe<Array<Maybe<AnalyticsEcommerceImpressions>>>;
};

export type AnalyticsEcommerceImpressions = {
    __typename?: 'AnalyticsEcommerceImpressions';
    id?: Maybe<Scalars['Int']>;
    list?: Maybe<Scalars['String']>;
    position?: Maybe<Scalars['Int']>;
    variant?: Maybe<Scalars['String']>;
};

export type AnalyticsTaxonomy = {
    __typename?: 'AnalyticsTaxonomy';
    url?: Maybe<Scalars['String']>;
    areaName?: Maybe<Scalars['String']>;
    activity?: Maybe<Scalars['String']>;
    brand?: Maybe<Scalars['String']>;
    countryCode?: Maybe<Scalars['String']>;
    countyAreaName?: Maybe<Scalars['String']>;
    currencyCode?: Maybe<Scalars['String']>;
    listingsCategory?: Maybe<Scalars['String']>;
    outcode?: Maybe<Scalars['String']>;
    outcodes?: Maybe<Array<Maybe<Scalars['String']>>>;
    page?: Maybe<Scalars['String']>;
    postalArea?: Maybe<Scalars['String']>;
    radius?: Maybe<Scalars['Float']>;
    radiusAutoexpansion?: Maybe<Scalars['String']>;
    regionName?: Maybe<Scalars['String']>;
    resultsSort?: Maybe<Scalars['String']>;
    searchGuid?: Maybe<Scalars['String']>;
    searchIdentifier?: Maybe<Scalars['String']>;
    searchLocation?: Maybe<Scalars['String']>;
    section?: Maybe<Scalars['String']>;
    viewType?: Maybe<Scalars['String']>;
    searchResultsCount?: Maybe<Scalars['Int']>;
    expandedResultsCount?: Maybe<Scalars['Int']>;
    totalResults?: Maybe<Scalars['Int']>;
    totalResultsWasLimited?: Maybe<Scalars['Boolean']>;
    emailAllFormShown?: Maybe<Scalars['Boolean']>;
    emailAllTotalAgents?: Maybe<Scalars['Int']>;
    priceMax?: Maybe<Scalars['String']>;
    priceMin?: Maybe<Scalars['String']>;
    bedsMax?: Maybe<Scalars['String']>;
    bedsMin?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
    location?: Maybe<Scalars['String']>;
};

export type AnalyticsTracking = {
    __typename?: 'AnalyticsTracking';
    metaData?: Maybe<MetaData>;
    taxonomy?: Maybe<DdpTaxonomy>;
    ecommerce?: Maybe<DdpEcommerce>;
};

export type Article = {
    __typename?: 'Article';
    id: Scalars['ID'];
    title: Scalars['String'];
    slug: Scalars['String'];
    category: ArticleCategory;
    snippet: Scalars['String'];
    publicationDateAndTime: Scalars['String'];
    heroImage: ContentImage;
};

export type ArticleCategories = {
    __typename?: 'ArticleCategories';
    items: Array<Maybe<ArticleCategory>>;
    total: Scalars['Int'];
};

export type ArticleCategory = {
    __typename?: 'ArticleCategory';
    name: Scalars['String'];
    slug: Scalars['String'];
};

export type Articles = {
    __typename?: 'Articles';
    items: Array<Maybe<Article>>;
    limit: Scalars['Int'];
    skip: Scalars['Int'];
    total: Scalars['Int'];
};

export type ArticleTag = {
    __typename?: 'ArticleTag';
    id: Scalars['ID'];
    label: Scalars['String'];
    slug: Scalars['String'];
    articles: Articles;
};

export type ArticleTagArticlesArgs = {
    category?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Int']>;
    skip?: Maybe<Scalars['Int']>;
};

export enum ArticleTagErrorStatusCode {
    ArticleTagNotFound = 'article_tag_not_found'
}

export type ArticleTagInvalidInputError = {
    __typename?: 'ArticleTagInvalidInputError';
    errorCode: ArticleTagErrorStatusCode;
};

export type ArticleTagResult = ArticleTag | ArticleTagInvalidInputError;

export type AskingPrice = {
    __typename?: 'AskingPrice';
    meanValue?: Maybe<Scalars['Float']>;
    numProperties?: Maybe<Scalars['Int']>;
};

export type AskingPrices = {
    __typename?: 'AskingPrices';
    forSale?: Maybe<AskingPrice>;
    toRent?: Maybe<AskingPrice>;
};

export type Attributes = {
    __typename?: 'Attributes';
    bedrooms?: Maybe<Scalars['Int']>;
    bathrooms?: Maybe<Scalars['Int']>;
    receptions?: Maybe<Scalars['Int']>;
};

export type Author = {
    __typename?: 'Author';
    id: Scalars['ID'];
    authorName: Scalars['String'];
    authorSlug: Scalars['String'];
    authorImage: ContentImage;
    jobTitle?: Maybe<Scalars['String']>;
    twitterHandle?: Maybe<Scalars['String']>;
    authorBio?: Maybe<RichText>;
    articles: Articles;
};

export type AuthorArticlesArgs = {
    category?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Int']>;
    skip?: Maybe<Scalars['Int']>;
};

export type AuthorDetails = IContentfulAuthor & {
    __typename?: 'AuthorDetails';
    id: Scalars['ID'];
    authorName?: Maybe<Scalars['String']>;
    authorSlug?: Maybe<Scalars['String']>;
    authorImage?: Maybe<ContentImage>;
    jobTitle?: Maybe<Scalars['String']>;
    twitterHandle?: Maybe<Scalars['String']>;
    authorBio?: Maybe<RichText>;
};

export enum AuthorErrorStatusCode {
    AuthorNotFound = 'author_not_found'
}

export type AuthorInvalidInputError = {
    __typename?: 'AuthorInvalidInputError';
    errorCode: AuthorErrorStatusCode;
};

export type AuthorResult = Author | AuthorInvalidInputError;

export type Authors = {
    __typename?: 'Authors';
    items: Array<Maybe<Author>>;
    limit: Scalars['Int'];
    skip: Scalars['Int'];
    total: Scalars['Int'];
};

export type BackToResultsLink = {
    __typename?: 'BackToResultsLink';
    linkType?: Maybe<BackToResultsLinkType>;
    uri?: Maybe<Scalars['String']>;
};

export enum BackToResultsLinkType {
    Personalised = 'personalised',
    Geo = 'geo'
}

export enum BestTimeToCallType {
    Anytime = 'anytime',
    Afternoon = 'afternoon',
    Evening = 'evening',
    Morning = 'morning'
}

export type Branch = {
    __typename?: 'Branch';
    branchDetailsUri?: Maybe<Scalars['String']>;
    logoUrl?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    phone?: Maybe<Scalars['String']>;
};

export type BranchAttributes = {
    __typename?: 'BranchAttributes';
    embeddedContentIsBlacklisted: Scalars['Boolean'];
};

export type BranchesValidation = {
    __typename?: 'BranchesValidation';
    requiredError?: Maybe<Scalars['Boolean']>;
};

export type Breadcrumbs = {
    __typename?: 'Breadcrumbs';
    label?: Maybe<Scalars['String']>;
    tracking?: Maybe<Scalars['String']>;
    uri?: Maybe<Scalars['String']>;
    i18nLabelKey?: Maybe<Scalars['String']>;
    noAppend?: Maybe<Scalars['Int']>;
};

export enum ConfidenceLevel {
    Low = 'LOW',
    Medium = 'MEDIUM',
    High = 'HIGH'
}

export type ConsentsInput = {
    consentName: Scalars['String'];
    consentGiven: Scalars['Boolean'];
};

export enum ContactPreference {
    NoPreference = 'NO_PREFERENCE',
    Phone = 'PHONE',
    Email = 'EMAIL'
}

export enum ContactTimePreference {
    NoPreference = 'NO_PREFERENCE',
    Morning = 'MORNING',
    Afternoon = 'AFTERNOON',
    Evening = 'EVENING'
}

export type ContentfulImage = {
    __typename?: 'ContentfulImage';
    url: Scalars['String'];
    altText?: Maybe<Scalars['String']>;
};

export type ContentImage = {
    __typename?: 'ContentImage';
    url: Scalars['String'];
};

export type DdpEcommerce = {
    __typename?: 'DDPEcommerce';
    outcode?: Maybe<Scalars['String']>;
};

export type DdpTaxonomy = {
    __typename?: 'DDPTaxonomy';
    groupId?: Maybe<Scalars['String']>;
    companyId?: Maybe<Scalars['String']>;
};

export type Developer = {
    __typename?: 'Developer';
    metaData?: Maybe<MetaData>;
    name?: Maybe<Scalars['String']>;
    description?: Maybe<Scalars['String']>;
};

export type DiscoverMore = {
    __typename?: 'DiscoverMore';
    findAgentsUri?: Maybe<Scalars['String']>;
    housePricesUri?: Maybe<Scalars['String']>;
};

export type DynamicAgentPhone =
    | DynamicAgentPhoneResultSuccess
    | DynamicAgentPhoneResultError;

export type DynamicAgentPhoneInput = {
    branchId: Scalars['Int'];
    phone: Scalars['String'];
    listingId: Scalars['Int'];
};

export type DynamicAgentPhoneResultError = {
    __typename?: 'DynamicAgentPhoneResultError';
    errorCode: DynamicAgentPhoneResultErrorCode;
};

export enum DynamicAgentPhoneResultErrorCode {
    AuthFailure = 'auth_failure',
    NoNumbersFound = 'no_numbers_found',
    ApplicationError = 'application_error',
    RequestTimeout = 'request_timeout',
    UnknownError = 'unknown_error'
}

export type DynamicAgentPhoneResultSuccess = {
    __typename?: 'DynamicAgentPhoneResultSuccess';
    phone: Scalars['String'];
};

export type EmailAll = {
    __typename?: 'EmailAll';
    action?: Maybe<Scalars['String']>;
    branches?: Maybe<Array<Maybe<EmailAllBranchContact>>>;
    branchesValidation?: Maybe<BranchesValidation>;
    formConfig?: Maybe<EmailAllFormConfig>;
    showCaptcha?: Maybe<Scalars['Boolean']>;
};

export type EmailAllBranchContact = {
    __typename?: 'EmailAllBranchContact';
    checked?: Maybe<Scalars['Boolean']>;
    featured?: Maybe<Scalars['Boolean']>;
    label?: Maybe<Scalars['String']>;
    logo?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    telephone?: Maybe<Scalars['String']>;
    value?: Maybe<Scalars['Int']>;
};

export type EmailAllDetails = {
    branches?: Maybe<Array<Maybe<Scalars['Int']>>>;
    email?: Maybe<Scalars['String']>;
    message?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    phone?: Maybe<Scalars['String']>;
    status?: Maybe<Scalars['String']>;
    uri?: Maybe<Scalars['String']>;
};

export type EmailAllFormConfig = {
    __typename?: 'EmailAllFormConfig';
    fields?: Maybe<Array<Maybe<EmailAllFormConfigFields>>>;
};

export type EmailAllFormConfigFields = {
    __typename?: 'EmailAllFormConfigFields';
    fieldset?: Maybe<EmailAllFormConfigFieldset>;
};

export type EmailAllFormConfigFieldset = {
    __typename?: 'EmailAllFormConfigFieldset';
    fields?: Maybe<Array<Maybe<EmailAllFormField>>>;
    hideLegend?: Maybe<Scalars['Boolean']>;
    i18NLegendKey?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
};

export type EmailAllFormField = {
    __typename?: 'EmailAllFormField';
    name?: Maybe<Scalars['String']>;
    placeholder?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    value?: Maybe<Scalars['String']>;
    i18NLabelKey?: Maybe<Scalars['String']>;
    maxlength?: Maybe<Scalars['String']>;
    optional?: Maybe<Scalars['Boolean']>;
    validationData?: Maybe<EmailAllFormFieldValidation>;
    options?: Maybe<Array<Maybe<EmailAllOption>>>;
};

export type EmailAllFormFieldValidation = {
    __typename?: 'EmailAllFormFieldValidation';
    pattern?: Maybe<Scalars['String']>;
    patternError?: Maybe<Scalars['Boolean']>;
    required?: Maybe<Scalars['Boolean']>;
    requiredError?: Maybe<Scalars['Boolean']>;
};

export type EmailAllOption = {
    __typename?: 'EmailAllOption';
    disabled?: Maybe<Scalars['Boolean']>;
    i18NLabelKey?: Maybe<Scalars['String']>;
    label?: Maybe<Scalars['String']>;
    selected?: Maybe<Scalars['Boolean']>;
    value?: Maybe<Scalars['String']>;
};

export type EmailAllResult = {
    __typename?: 'EmailAllResult';
    branches?: Maybe<Array<Maybe<EmailAllResultBranches>>>;
    leadIdentifier?: Maybe<Scalars['String']>;
    message?: Maybe<Scalars['String']>;
    trackingObjects?: Maybe<Array<Maybe<EmailAllResultTracking>>>;
};

export type EmailAllResultBranches = {
    __typename?: 'EmailAllResultBranches';
    address?: Maybe<Scalars['String']>;
    branchDetailsUri?: Maybe<Scalars['String']>;
    branchDetailsUrl?: Maybe<Scalars['String']>;
    branchId?: Maybe<Scalars['Int']>;
    companyId?: Maybe<Scalars['Int']>;
    companyName?: Maybe<Scalars['String']>;
    logoUrl?: Maybe<Scalars['String']>;
    memberType?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    phone?: Maybe<Scalars['String']>;
    postcode?: Maybe<Scalars['String']>;
};

export type EmailAllResultEcommerce = {
    __typename?: 'EmailAllResultEcommerce';
    purchase?: Maybe<EmailAllResultEcommercePurchase>;
};

export type EmailAllResultEcommerceProduct = {
    __typename?: 'EmailAllResultEcommerceProduct';
    brand?: Maybe<Scalars['String']>;
    category?: Maybe<Scalars['String']>;
    coupon?: Maybe<Scalars['String']>;
    id?: Maybe<Scalars['Int']>;
    name?: Maybe<Scalars['String']>;
    position?: Maybe<Scalars['String']>;
    price?: Maybe<Scalars['Int']>;
    quantity?: Maybe<Scalars['String']>;
    variant?: Maybe<Scalars['String']>;
};

export type EmailAllResultEcommercePurchase = {
    __typename?: 'EmailAllResultEcommercePurchase';
    actionField?: Maybe<EmailAllResultEcommercePurchaseAction>;
    products?: Maybe<Array<Maybe<EmailAllResultEcommerceProduct>>>;
};

export type EmailAllResultEcommercePurchaseAction = {
    __typename?: 'EmailAllResultEcommercePurchaseAction';
    affiliation?: Maybe<Scalars['String']>;
    id?: Maybe<Scalars['String']>;
    revenue?: Maybe<Scalars['Int']>;
};

export type EmailAllResultTracking = {
    __typename?: 'EmailAllResultTracking';
    ecommerce?: Maybe<EmailAllResultEcommerce>;
};

export type EmailAllSubmission = {
    __typename?: 'EmailAllSubmission';
    emailAll?: Maybe<EmailAll>;
    result?: Maybe<EmailAllResult>;
};

export type EmailLeadFormFields = {
    __typename?: 'EmailLeadFormFields';
    email?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    phone?: Maybe<Scalars['String']>;
    postcode?: Maybe<Scalars['String']>;
    status?: Maybe<Scalars['String']>;
};

export type EmailLeadInfo = {
    __typename?: 'EmailLeadInfo';
    showCaptcha: Scalars['Boolean'];
    uniqueLeadIdentifier?: Maybe<Scalars['String']>;
    formFields?: Maybe<EmailLeadFormFields>;
};

export type EmailLeadInput = {
    name: Scalars['String'];
    phone: Scalars['String'];
    email: Scalars['String'];
    message?: Maybe<Scalars['String']>;
    postcode?: Maybe<Scalars['String']>;
    senderPropertyStatus?: Maybe<Scalars['String']>;
    interest?: Maybe<Scalars['Boolean']>;
    availability?: Maybe<Array<Maybe<Scalars['String']>>>;
    captchaToken?: Maybe<Scalars['String']>;
    searchIdentifier?: Maybe<Scalars['String']>;
};

export type EmailLeadResponse = {
    __typename?: 'EmailLeadResponse';
    success: Scalars['Boolean'];
    uniqueLeadIdentifier: Scalars['String'];
};

export type EmbeddedContent = {
    __typename?: 'EmbeddedContent';
    videos?: Maybe<Array<Media>>;
    tours?: Maybe<Array<Media>>;
    smartViewings?: Maybe<Array<Media>>;
    links?: Maybe<Array<Media>>;
};

export enum EnquiryType {
    LookingToBuy = 'LOOKING_TO_BUY'
}

export type Epc = {
    __typename?: 'EPC';
    image?: Maybe<Array<Media>>;
    pdf?: Maybe<Array<Media>>;
};

export type Estimate = {
    __typename?: 'Estimate';
    sale: SaleEstimate;
    rent?: Maybe<RentEstimate>;
};

export type ExtendedDevelopmentData = {
    __typename?: 'ExtendedDevelopmentData';
    descriptionSummary?: Maybe<Scalars['String']>;
    availableFromDate?: Maybe<Scalars['String']>;
    hbfRating?: Maybe<Scalars['Int']>;
    developerDescription?: Maybe<Scalars['String']>;
    keyDevelopmentFeatures?: Maybe<Array<Maybe<Scalars['String']>>>;
    propertyTypesAvailable?: Maybe<Array<Maybe<Scalars['String']>>>;
    launchDate?: Maybe<Scalars['String']>;
    launchDateSeason?: Maybe<Scalars['String']>;
    /** @deprecated Use `launchDate` to infer project stage. */
    timeline?: Maybe<Timeline>;
};

export type Faq = {
    __typename?: 'Faq';
    question: Scalars['String'];
    answer: RichText;
};

export type Favourites = {
    __typename?: 'Favourites';
    listings?: Maybe<Array<Maybe<Scalars['ID']>>>;
    properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type Feature = {
    __typename?: 'Feature';
    iconId?: Maybe<Scalars['String']>;
    content?: Maybe<Scalars['Int']>;
};

export type FeatureFlag = {
    __typename?: 'FeatureFlag';
    furnishedState?: Maybe<Label>;
    studentFriendly: Scalars['Boolean'];
    tenure?: Maybe<Label>;
    availableFromDate?: Maybe<Scalars['String']>;
};

export type FeatureHighlight = {
    __typename?: 'FeatureHighlight';
    description?: Maybe<Scalars['String']>;
    label: Scalars['String'];
};

export type Features = {
    __typename?: 'Features';
    bullets?: Maybe<Array<Scalars['String']>>;
    flags?: Maybe<FeatureFlag>;
    highlights?: Maybe<Array<FeatureHighlight>>;
    detailedDescription?: Maybe<Scalars['String']>;
};

export type Filters = {
    __typename?: 'Filters';
    action?: Maybe<Scalars['String']>;
    fields?: Maybe<Array<Maybe<FiltersFields>>>;
};

export type FiltersFields = {
    __typename?: 'FiltersFields';
    group?: Maybe<Scalars['String']>;
    fieldName?: Maybe<Scalars['String']>;
    label?: Maybe<Scalars['String']>;
    isRequired?: Maybe<Scalars['Boolean']>;
    inputType?: Maybe<Scalars['String']>;
    placeholder?: Maybe<Scalars['String']>;
    allowMultiple?: Maybe<Scalars['Boolean']>;
    options?: Maybe<Array<Maybe<Scalars['String']>>>;
    value?: Maybe<Scalars['String']>;
};

export type FloorArea = {
    __typename?: 'FloorArea';
    unitsLabel: Scalars['String'];
    label: Scalars['String'];
    units: Scalars['String'];
    range?: Maybe<FloorAreaRange>;
    value?: Maybe<Scalars['Float']>;
};

export type FloorAreaRange = {
    __typename?: 'FloorAreaRange';
    maxValue: Scalars['Float'];
    maxValueLabel: Scalars['String'];
    minValue: Scalars['Float'];
    minValueLabel: Scalars['String'];
};

export type FloorPlan = {
    __typename?: 'FloorPlan';
    image?: Maybe<Array<Media>>;
    links?: Maybe<Array<LinkData>>;
    pdf?: Maybe<Array<Media>>;
};

export type GeoSuggestion = {
    __typename?: 'GeoSuggestion';
    geoIdentifier?: Maybe<Scalars['String']>;
    geoLabel?: Maybe<Scalars['String']>;
    geoSubLabel?: Maybe<Scalars['String']>;
};

export type GovSchemesData = {
    __typename?: 'GovSchemesData';
    header?: Maybe<Header>;
    keyBenefits?: Maybe<KeyBenefitsDetails>;
    quote?: Maybe<Quote>;
    priceCaps?: Maybe<RichText>;
    schemeDescription?: Maybe<RichTextAndImage>;
    howSchemeWorks?: Maybe<RichTextAndImage>;
    schemeTypeComparisonTable?: Maybe<Table>;
    schemeVersionComparisonTable?: Maybe<Table>;
    prosAndConsDetails?: Maybe<ProsAndConsDetails>;
    secondarySearch?: Maybe<SecondarySearch>;
    seoSearchLinks?: Maybe<SeoSearchLinks>;
    faqs?: Maybe<Array<Maybe<Faq>>>;
};

export type Header = {
    __typename?: 'Header';
    heroImage?: Maybe<Scalars['String']>;
    heading?: Maybe<Scalars['String']>;
    subHeading?: Maybe<Scalars['String']>;
    searchLabel?: Maybe<Scalars['String']>;
    searchButtonText?: Maybe<Scalars['String']>;
    searchFilterType?: Maybe<Scalars['String']>;
};

export type Highlight = {
    __typename?: 'Highlight';
    description?: Maybe<Scalars['String']>;
    label?: Maybe<Scalars['String']>;
    url?: Maybe<Scalars['String']>;
};

export type HistoricalEstimate = {
    __typename?: 'HistoricalEstimate';
    overMonth?: Maybe<Scalars['String']>;
    value?: Maybe<Scalars['Int']>;
    pctChangeSince?: Maybe<Scalars['Float']>;
    date?: Maybe<Scalars['String']>;
    changeSince?: Maybe<Scalars['Int']>;
};

export type HistoricalSales = {
    __typename?: 'HistoricalSales';
    overYear?: Maybe<Scalars['String']>;
    mean?: Maybe<Scalars['Float']>;
    newBuilds?: Maybe<Scalars['Int']>;
    numSales?: Maybe<Scalars['Int']>;
};

export type HistoricEvent = {
    __typename?: 'HistoricEvent';
    percentageChange?: Maybe<Scalars['Float']>;
    date: Scalars['String'];
    numericChange?: Maybe<Scalars['Int']>;
    price: Scalars['Int'];
    priceType?: Maybe<Scalars['String']>;
    type: Scalars['String'];
    uri?: Maybe<Scalars['String']>;
    attributes?: Maybe<Attributes>;
    images?: Maybe<Array<HistoricImage>>;
    floorplans?: Maybe<Array<HistoricImage>>;
};

export type HistoricImage = {
    __typename?: 'HistoricImage';
    thumbnail: Scalars['String'];
    medium: Scalars['String'];
    large: Scalars['String'];
};

export type History = {
    __typename?: 'History';
    historicEvents: Array<HistoricEvent>;
    soldPricesDataSource?: Maybe<Scalars['String']>;
};

export type IContentfulAuthor = {
    id: Scalars['ID'];
    authorName?: Maybe<Scalars['String']>;
    authorSlug?: Maybe<Scalars['String']>;
    authorImage?: Maybe<ContentImage>;
    jobTitle?: Maybe<Scalars['String']>;
    twitterHandle?: Maybe<Scalars['String']>;
    authorBio?: Maybe<RichText>;
};

export type IContentfulQuote = {
    id: Scalars['ID'];
    description?: Maybe<Scalars['String']>;
};

export type IListing = {
    listingId: Scalars['ID'];
    pricing: ListingPricing;
    counts: RoomCount;
    section?: Maybe<Scalars['String']>;
    floorArea?: Maybe<FloorArea>;
    propertyType?: Maybe<Scalars['String']>;
};

export type Image = {
    __typename?: 'Image';
    src?: Maybe<Scalars['String']>;
    caption?: Maybe<Scalars['String']>;
    responsiveImgList?: Maybe<Array<Maybe<ResponsiveImg>>>;
};

export type Item = {
    __typename?: 'Item';
    id: Scalars['ID'];
    subnavs?: Maybe<Array<Maybe<Subnav>>>;
    order?: Maybe<Scalars['Int']>;
    label?: Maybe<Scalars['String']>;
    uri?: Maybe<Scalars['String']>;
    i18nLabelKey?: Maybe<Scalars['String']>;
    tracking?: Maybe<Scalars['String']>;
};

export type KeyBenefit = {
    __typename?: 'KeyBenefit';
    headline?: Maybe<Scalars['String']>;
    icon?: Maybe<Scalars['String']>;
    description?: Maybe<Scalars['String']>;
};

export type KeyBenefitsDetails = {
    __typename?: 'KeyBenefitsDetails';
    title?: Maybe<Scalars['String']>;
    items?: Maybe<Array<Maybe<KeyBenefit>>>;
};

export type Label = {
    __typename?: 'Label';
    name: Scalars['String'];
    label: Scalars['String'];
};

export type Link = {
    __typename?: 'Link';
    category?: Maybe<Scalars['String']>;
    geo?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
    section?: Maybe<Scalars['String']>;
    transactionType?: Maybe<Scalars['String']>;
    uri?: Maybe<Scalars['String']>;
};

export type LinkData = {
    __typename?: 'LinkData';
    label: Scalars['String'];
    url: Scalars['String'];
};

export type Links = {
    __typename?: 'Links';
    saveSearch?: Maybe<Scalars['String']>;
    createAlert?: Maybe<Scalars['String']>;
    mapView?: Maybe<Scalars['String']>;
};

export type Listing = {
    __typename?: 'Listing';
    listingId: Scalars['ID'];
    price?: Maybe<Scalars['String']>;
    priceTitle?: Maybe<Scalars['String']>;
    shortPriceTitle?: Maybe<Scalars['String']>;
    priceDrop?: Maybe<PriceDrop>;
    branch?: Maybe<Branch>;
    title?: Maybe<Scalars['String']>;
    address?: Maybe<Scalars['String']>;
    publishedOnLabel?: Maybe<Scalars['String']>;
    publishedOn?: Maybe<Scalars['String']>;
    availableFrom?: Maybe<Scalars['String']>;
    tags?: Maybe<Array<Maybe<Tag>>>;
    features?: Maybe<Array<Maybe<Feature>>>;
    image?: Maybe<Image>;
    flag?: Maybe<Scalars['String']>;
    transports?: Maybe<Array<Maybe<Transport>>>;
    isPremium?: Maybe<Scalars['Boolean']>;
    otherPropertyImages?: Maybe<Array<Maybe<SubImage>>>;
    highlights?: Maybe<Array<Maybe<Highlight>>>;
    displayType?: Maybe<Scalars['String']>;
    numberOfVideos?: Maybe<Scalars['Int']>;
    numberOfFloorPlans?: Maybe<Scalars['Int']>;
    numberOfImages?: Maybe<Scalars['Int']>;
    numberOfViews?: Maybe<Scalars['Int']>;
    listingUris?: Maybe<ListingUris>;
    featuredType?: Maybe<Scalars['String']>;
    location?: Maybe<ListingLocation>;
    section?: Maybe<Scalars['String']>;
    publicationStatus: PublicationStatus;
};

export type ListingAnalyticsEcommerce = {
    __typename?: 'ListingAnalyticsEcommerce';
    brand: Scalars['String'];
    category: Scalars['String'];
    id: Scalars['Int'];
    name: Scalars['String'];
    price: Scalars['Float'];
    quantity: Scalars['Int'];
    variant: Scalars['String'];
};

export type ListingAnalyticsTaxonomy = {
    __typename?: 'ListingAnalyticsTaxonomy';
    acorn?: Maybe<Scalars['Int']>;
    acornType?: Maybe<Scalars['Int']>;
    areaName: Scalars['String'];
    bedsMax?: Maybe<Scalars['Int']>;
    bedsMin?: Maybe<Scalars['Int']>;
    branchId?: Maybe<Scalars['Int']>;
    branchLogoUrl?: Maybe<Scalars['String']>;
    branchName: Scalars['String'];
    brandName: Scalars['String'];
    chainFree: Scalars['Boolean'];
    companyId?: Maybe<Scalars['Int']>;
    countryCode: Scalars['String'];
    countyAreaName: Scalars['String'];
    currencyCode: Scalars['String'];
    displayAddress: Scalars['String'];
    furnishedState: Scalars['String'];
    groupId?: Maybe<Scalars['Int']>;
    hasEpc: Scalars['Boolean'];
    hasFloorplan: Scalars['Boolean'];
    incode: Scalars['String'];
    isRetirementHome: Scalars['Boolean'];
    isSharedOwnership: Scalars['Boolean'];
    listingCondition: Scalars['String'];
    listingId: Scalars['Int'];
    listingsCategory: Scalars['String'];
    listingStatus: Scalars['String'];
    location: Scalars['String'];
    memberType: Scalars['String'];
    numBaths?: Maybe<Scalars['Int']>;
    numBeds?: Maybe<Scalars['Int']>;
    numImages: Scalars['Int'];
    numRecepts?: Maybe<Scalars['Int']>;
    outcode: Scalars['String'];
    postalArea: Scalars['String'];
    postTownName: Scalars['String'];
    priceActual?: Maybe<Scalars['Float']>;
    price?: Maybe<Scalars['Float']>;
    priceMax?: Maybe<Scalars['Float']>;
    priceMin?: Maybe<Scalars['Float']>;
    priceQualifier: Scalars['String'];
    propertyHighlight?: Maybe<Scalars['String']>;
    propertyType: Scalars['String'];
    regionName: Scalars['String'];
    section: Scalars['String'];
    sizeSqFeet: Scalars['String'];
    tenure?: Maybe<Scalars['String']>;
    zindex?: Maybe<Scalars['Int']>;
};

export enum ListingCategory {
    Residential = 'residential',
    Commercial = 'commercial'
}

export type ListingData = IListing & {
    __typename?: 'ListingData';
    administrationFees?: Maybe<Scalars['String']>;
    analyticsEcommerce: ListingAnalyticsEcommerce;
    analyticsTaxonomy: ListingAnalyticsTaxonomy;
    adTargeting: ListingAnalyticsTaxonomy;
    branch?: Maybe<AgentBranch>;
    category?: Maybe<ListingCategory>;
    content: MediaContent;
    additionalLinks?: Maybe<Array<MediaOrAdditionalLink>>;
    counts: RoomCount;
    detailedDescription?: Maybe<Scalars['String']>;
    displayAddress?: Maybe<Scalars['String']>;
    embeddedContent?: Maybe<EmbeddedContent>;
    section?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
    epc?: Maybe<Epc>;
    features?: Maybe<Features>;
    featurePreview?: Maybe<Array<Maybe<Feature>>>;
    floorArea?: Maybe<FloorArea>;
    floorPlan?: Maybe<FloorPlan>;
    listingId: Scalars['ID'];
    listingUris: ListingUris;
    location?: Maybe<ListingLocation>;
    metaDescription: Scalars['String'];
    metaTitle: Scalars['String'];
    pricing: ListingPricing;
    propertyImage?: Maybe<Array<Media>>;
    statusSummary?: Maybe<ListingStatusSummary>;
    tags?: Maybe<Array<ListingTag>>;
    title: Scalars['String'];
    pointsOfInterest?: Maybe<Array<PointOfInterest>>;
    priceHistory?: Maybe<PriceHistory>;
    viewCount?: Maybe<ViewCount>;
    similarListings?: Maybe<Array<Maybe<Listing>>>;
    marketStats?: Maybe<MarketStats>;
    emailLead?: Maybe<EmailLeadInfo>;
    publicationStatus?: Maybe<PublicationStatus>;
    imagePreview?: Maybe<Image>;
    publishedOn?: Maybe<Scalars['String']>;
    numberOfImages?: Maybe<Scalars['Int']>;
    transports?: Maybe<Array<Maybe<Transport>>>;
};

export type ListingDataSimilarListingsArgs = {
    first?: Maybe<Scalars['Int']>;
};

export type ListingLocation = {
    __typename?: 'ListingLocation';
    coordinates?: Maybe<LocationCoordinates>;
    postalCode?: Maybe<Scalars['String']>;
    countryCode?: Maybe<Scalars['String']>;
    streetName?: Maybe<Scalars['String']>;
    propertyNumberOrName?: Maybe<Scalars['String']>;
    townOrCity?: Maybe<Scalars['String']>;
};

export type ListingPricing = {
    __typename?: 'ListingPricing';
    alternateRentFrequencyPrice?: Maybe<PriceInfo>;
    internalValue: Scalars['Float'];
    label: Scalars['String'];
    pricePerFloorAreaUnit?: Maybe<PriceInfo>;
    qualifier?: Maybe<Scalars['String']>;
    priceQualifierLabel?: Maybe<Scalars['String']>;
    rentFrequencyLabel?: Maybe<Scalars['String']>;
    isAuction: Scalars['Boolean'];
};

export type Listings = {
    __typename?: 'Listings';
    /**
     * This contains the search results listings
     * - regular - just normal search results
     * - extended -if you get more than zero but less than ten results from your
     * search and haven't specified an explicit radius, it'll try to expand the
     * radius until it gets up to 25 extra results
     * - featured - a number of listings that should be displayed as featured on the LSRP page
     */
    regular?: Maybe<Array<Maybe<Listing>>>;
    extended?: Maybe<Array<Maybe<Listing>>>;
    featured?: Maybe<Array<Maybe<Listing>>>;
};

export type ListingsDetails = {
    __typename?: 'ListingsDetails';
    metaData?: Maybe<MetaData>;
    filterByPrice?: Maybe<Array<Maybe<Scalars['Float']>>>;
    filterByBeds?: Maybe<Array<Maybe<Scalars['Int']>>>;
    hasOnlyPriceOnAsk?: Maybe<Scalars['Boolean']>;
    listings?: Maybe<Array<Maybe<NewHomesListing>>>;
};

export enum ListingStatus {
    ForSale = 'for_sale',
    SaleUnderOffer = 'sale_under_offer',
    Sold = 'sold',
    ToRent = 'to_rent',
    RentUnderOffer = 'rent_under_offer',
    Rented = 'rented'
}

export type ListingStatusSummary = {
    __typename?: 'ListingStatusSummary';
    label?: Maybe<Scalars['String']>;
};

export type ListingTag = {
    __typename?: 'ListingTag';
    label: Scalars['String'];
};

export type ListingUris = {
    __typename?: 'ListingUris';
    detail?: Maybe<Scalars['String']>;
    contact?: Maybe<Scalars['String']>;
    smartViewing?: Maybe<Scalars['String']>;
    success?: Maybe<Scalars['String']>;
};

export type LiveListing = {
    __typename?: 'LiveListing';
    branchName: Scalars['String'];
    displayAddress?: Maybe<Scalars['String']>;
    listingId: Scalars['String'];
    price?: Maybe<Scalars['Int']>;
    rentPerMonth?: Maybe<Scalars['Int']>;
    totalBedrooms?: Maybe<Scalars['Int']>;
    transactionType: Scalars['String'];
    uri: Scalars['String'];
};

export type LocationCoordinates = {
    __typename?: 'LocationCoordinates';
    latitude?: Maybe<Scalars['Float']>;
    longitude?: Maybe<Scalars['Float']>;
};

export type MarketingDetails = {
    __typename?: 'MarketingDetails';
    metaData?: Maybe<MetaData>;
    address?: Maybe<Scalars['String']>;
    postcode?: Maybe<Scalars['String']>;
    openHours?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MarketStats = {
    __typename?: 'MarketStats';
    areaName?: Maybe<Scalars['String']>;
    areaNameUri?: Maybe<Scalars['String']>;
    askingPrices?: Maybe<AskingPrices>;
    propertyTypeGroup?: Maybe<PropertyTypeGroup>;
    historicalEstimates?: Maybe<Array<Maybe<HistoricalEstimate>>>;
    sales?: Maybe<Array<Maybe<HistoricalSales>>>;
    recentSales?: Maybe<Array<RecentSale>>;
};

export type Media = {
    __typename?: 'Media';
    caption?: Maybe<Scalars['String']>;
    mimeType?: Maybe<Scalars['String']>;
    originalMimeType?: Maybe<Scalars['String']>;
    original?: Maybe<Scalars['String']>;
    url?: Maybe<Scalars['String']>;
    filename?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
};

export type MediaContent = {
    __typename?: 'MediaContent';
    floorPlan?: Maybe<Array<Media>>;
    virtualTour?: Maybe<Array<Media>>;
    audioTour?: Maybe<Array<Media>>;
};

export type MediaOrAdditionalLink = Media | AdditionalLink;

export type MeetTheTeam = {
    __typename?: 'MeetTheTeam';
    id: Scalars['ID'];
    slug: Scalars['String'];
    title: Scalars['String'];
    description?: Maybe<Scalars['String']>;
    metaDescription: Scalars['String'];
    authors: Authors;
};

export type MeetTheTeamAuthorsArgs = {
    limit?: Maybe<Scalars['Int']>;
    skip?: Maybe<Scalars['Int']>;
};

export enum MeetTheTeamErrorStatusCode {
    EntryNotFound = 'entry_not_found'
}

export type MeetTheTeamInvalidInputError = {
    __typename?: 'MeetTheTeamInvalidInputError';
    errorCode: MeetTheTeamErrorStatusCode;
};

export type MeetTheTeamResult = MeetTheTeam | MeetTheTeamInvalidInputError;

export enum MemberType {
    Agent = 'agent',
    Developer = 'developer'
}

export type Meta = {
    __typename?: 'Meta';
    title?: Maybe<Scalars['String']>;
    description?: Maybe<Scalars['String']>;
    keywords?: Maybe<Scalars['String']>;
    robots?: Maybe<Scalars['String']>;
    canonicalUri?: Maybe<Scalars['String']>;
};

export type MetaData = {
    __typename?: 'MetaData';
    id: Scalars['Int'];
    deprecatedBranchId: Scalars['Int'];
};

export type Mutation = {
    __typename?: 'Mutation';
    saveFavouriteListing?: Maybe<Scalars['Boolean']>;
    deleteFavouriteListing?: Maybe<Scalars['Boolean']>;
    saveFavouriteProperty?: Maybe<Scalars['Boolean']>;
    deleteFavouriteProperty?: Maybe<Scalars['Boolean']>;
    saveTrackedProperty?: Maybe<Scalars['Boolean']>;
    deleteTrackedProperty?: Maybe<Scalars['Boolean']>;
    /**
     * Registers a user. Automatically logs them in if the session id
     * and persistent session id are in the cookie.
     */
    registerUser?: Maybe<RegisterUserPayload>;
    signinUser?: Maybe<SigninUserPayload>;
    contactAgents?: Maybe<EmailAllSubmission>;
    sendContactAgentLead?: Maybe<NewHomesLeadResponse>;
    sendArrangeViewingLead?: Maybe<NewHomesLeadResponse>;
    updateSavedSearch?: Maybe<SimpleResponse>;
    createNewSavedSearch?: Maybe<SimpleResponse>;
    createNewEmailAlert?: Maybe<SimpleResponse>;
    socialSignInGoogle?: Maybe<SocialSignInGoogleResponse>;
    socialSignInGoogleOneTap?: Maybe<SocialSignInGoogleOneTapResponse>;
    socialSignInFacebook?: Maybe<SocialSignInFacebookResponse>;
    updateUserConsents?: Maybe<Scalars['Boolean']>;
    updateUserAboutMe?: Maybe<Scalars['Boolean']>;
    createValuationLead: ValuationLeadResponse;
    createEmailLead: EmailLeadResponse;
    saveUserListing: SavedListingUpdateResult;
    deleteUserListings: SavedListingUpdateResult;
    createDynamicAgentPhone: DynamicAgentPhone;
    createZooplaValuationToolValuation?: Maybe<ZvtFormSubmissionValuationResponse>;
    validateZooplaValuationToolEmail?: Maybe<ZvtValidateEmailResponse>;
};

export type MutationSaveFavouriteListingArgs = {
    id: Scalars['ID'];
};

export type MutationDeleteFavouriteListingArgs = {
    id: Scalars['ID'];
};

export type MutationSaveFavouritePropertyArgs = {
    id: Scalars['ID'];
};

export type MutationDeleteFavouritePropertyArgs = {
    id: Scalars['ID'];
};

export type MutationSaveTrackedPropertyArgs = {
    trackedProperty?: Maybe<TrackedPropertyInput>;
};

export type MutationDeleteTrackedPropertyArgs = {
    propertyId: Scalars['String'];
    uprn: Scalars['String'];
};

export type MutationRegisterUserArgs = {
    input: RegisterUserInput;
};

export type MutationSigninUserArgs = {
    input: SigninUserInput;
};

export type MutationContactAgentsArgs = {
    input: EmailAllDetails;
};

export type MutationSendContactAgentLeadArgs = {
    input: NewHomesLeadInput;
};

export type MutationSendArrangeViewingLeadArgs = {
    input: NewHomesLeadInput;
};

export type MutationUpdateSavedSearchArgs = {
    input: SearchFields;
};

export type MutationCreateNewSavedSearchArgs = {
    input: SearchFields;
};

export type MutationCreateNewEmailAlertArgs = {
    input: SearchFields;
};

export type MutationSocialSignInGoogleArgs = {
    accessToken: Scalars['String'];
};

export type MutationSocialSignInGoogleOneTapArgs = {
    accessToken: Scalars['String'];
};

export type MutationSocialSignInFacebookArgs = {
    accessToken: Scalars['String'];
};

export type MutationUpdateUserConsentsArgs = {
    input: UpdateUserConsentsInput;
};

export type MutationUpdateUserAboutMeArgs = {
    input: UserAboutMeInput;
};

export type MutationCreateValuationLeadArgs = {
    lead: ValuationLeadInput;
};

export type MutationCreateEmailLeadArgs = {
    id: Scalars['Int'];
    lead: EmailLeadInput;
};

export type MutationSaveUserListingArgs = {
    listingId: Scalars['Int'];
};

export type MutationDeleteUserListingsArgs = {
    listingIds: Array<Scalars['Int']>;
};

export type MutationCreateDynamicAgentPhoneArgs = {
    input: DynamicAgentPhoneInput;
};

export type MutationCreateZooplaValuationToolValuationArgs = {
    input: ZvtFormSubmissionValuationInput;
};

export type MutationValidateZooplaValuationToolEmailArgs = {
    input: ZvtValidateEmailInput;
};

export type Navbar = {
    __typename?: 'Navbar';
    id: Scalars['ID'];
    name?: Maybe<Scalars['String']>;
    items?: Maybe<Array<Maybe<Item>>>;
};

export type NewHomesDevelopmentData = {
    __typename?: 'NewHomesDevelopmentData';
    metaData?: Maybe<MetaData>;
    name?: Maybe<Scalars['String']>;
    logoUri?: Maybe<Scalars['String']>;
    listingsCount?: Maybe<Scalars['Int']>;
    bedrooms?: Maybe<Scalars['String']>;
    helpToBuy?: Maybe<Scalars['Boolean']>;
    sharedOwnership?: Maybe<Scalars['Boolean']>;
    retirement?: Maybe<Scalars['Boolean']>;
    description?: Maybe<Scalars['String']>;
    minimumPlotPrice?: Maybe<Scalars['Float']>;
    images?: Maybe<Array<Maybe<Scalars['String']>>>;
    address?: Maybe<Scalars['String']>;
    town?: Maybe<Scalars['String']>;
    postcode?: Maybe<Scalars['String']>;
    developer?: Maybe<Developer>;
    latitude?: Maybe<Scalars['Float']>;
    longitude?: Maybe<Scalars['Float']>;
    pointsOfInterest?: Maybe<Array<Maybe<PointOfInterest>>>;
    marketingDetails?: Maybe<MarketingDetails>;
    analyticsTracking?: Maybe<AnalyticsTracking>;
    extendedDevelopmentData?: Maybe<ExtendedDevelopmentData>;
    listingsDetails?: Maybe<ListingsDetails>;
};

export type NewHomesLeadInput = {
    typeOfEnquiry?: Maybe<EnquiryType>;
    branchId?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    phone?: Maybe<Scalars['String']>;
    email?: Maybe<Scalars['String']>;
    message?: Maybe<Scalars['String']>;
    bestTimeToCall?: Maybe<BestTimeToCallType>;
    marketingOptIn?: Maybe<Scalars['Boolean']>;
    aboutMe?: Maybe<Scalars['String']>;
    lookingToMove?: Maybe<Scalars['String']>;
};

export type NewHomesLeadResponse = {
    __typename?: 'NewHomesLeadResponse';
    success?: Maybe<Scalars['Boolean']>;
    uniqueLeadIdentifier?: Maybe<Scalars['String']>;
};

export type NewHomesListing = IListing & {
    __typename?: 'NewHomesListing';
    listingId: Scalars['ID'];
    pricing: ListingPricing;
    counts: RoomCount;
    section?: Maybe<Scalars['String']>;
    floorArea?: Maybe<FloorArea>;
    propertyType?: Maybe<Scalars['String']>;
    isPriceOnAsk?: Maybe<Scalars['Boolean']>;
    garden?: Maybe<Scalars['Boolean']>;
    garage?: Maybe<Scalars['Boolean']>;
    balcony?: Maybe<Scalars['Boolean']>;
    terrace?: Maybe<Scalars['Boolean']>;
    helpToBuy?: Maybe<Scalars['Boolean']>;
    sharedOwnership?: Maybe<Scalars['Boolean']>;
    retirement?: Maybe<Scalars['Boolean']>;
    parking?: Maybe<Scalars['Boolean']>;
};

export type PageInfo = {
    __typename?: 'PageInfo';
    hasPreviousPage: Scalars['Boolean'];
    hasNextPage: Scalars['Boolean'];
    startCursor: Scalars['ID'];
    endCursor: Scalars['ID'];
};

export type Pagination = {
    __typename?: 'Pagination';
    nextPageUri?: Maybe<Scalars['String']>;
    pageEndIndex?: Maybe<Scalars['Int']>;
    pageNumber?: Maybe<Scalars['Int']>;
    pageNumberMax?: Maybe<Scalars['Int']>;
    pageStartIndex?: Maybe<Scalars['Int']>;
    totalResults?: Maybe<Scalars['Int']>;
    totalResultsWasLimited?: Maybe<Scalars['Boolean']>;
};

export type PastSuggestedAddresses = {
    __typename?: 'PastSuggestedAddresses';
    v?: Maybe<Scalars['String']>;
};

export type PathByParamFields = {
    filters: PathByParamSearchFields;
    searchSource: Scalars['String'];
    sortOrder?: Maybe<Scalars['String']>;
    userAlertId?: Maybe<Scalars['String']>;
    excludeRadius?: Maybe<Scalars['Boolean']>;
    page?: Maybe<Scalars['Int']>;
};

export type PathByParamSearchFields = {
    description?: Maybe<Scalars['String']>;
    userAlertId?: Maybe<Scalars['String']>;
    q: Scalars['String'];
    section: Scalars['String'];
    category?: Maybe<Scalars['String']>;
    priceFrequency?: Maybe<Scalars['String']>;
    includeSharedAccommodation?: Maybe<Scalars['String']>;
    keywords?: Maybe<Scalars['String']>;
    identifier?: Maybe<Scalars['String']>;
    radius?: Maybe<Scalars['String']>;
    added?: Maybe<Scalars['String']>;
    availableFrom?: Maybe<Scalars['String']>;
    priceMin?: Maybe<Scalars['String']>;
    priceMax?: Maybe<Scalars['String']>;
    bedsMin?: Maybe<Scalars['String']>;
    bedsMax?: Maybe<Scalars['String']>;
    rentalTerm?: Maybe<Scalars['String']>;
    petsAllowed?: Maybe<Scalars['String']>;
    billsIncluded?: Maybe<Scalars['String']>;
    includeSold?: Maybe<Scalars['String']>;
    includeRented?: Maybe<Scalars['String']>;
    furnishedState?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
    propertySubType?: Maybe<Array<Maybe<Scalars['String']>>>;
    feature?: Maybe<Array<Maybe<Scalars['String']>>>;
    includeRetirementHomes?: Maybe<Scalars['String']>;
    isRetirementHome?: Maybe<Scalars['String']>;
    includeSharedOwnership?: Maybe<Scalars['String']>;
    isSharedOwnership?: Maybe<Scalars['String']>;
    buyerIncentive?: Maybe<Scalars['String']>;
    newHomes?: Maybe<Scalars['String']>;
    isAuction?: Maybe<Scalars['String']>;
    chainFree?: Maybe<Scalars['String']>;
    reducedPriceOnly?: Maybe<Scalars['String']>;
    viewType?: Maybe<Scalars['String']>;
    polyenc?: Maybe<Scalars['String']>;
};

export type PerlNavigationData = {
    __typename?: 'PerlNavigationData';
    accordions?: Maybe<Array<Maybe<SeoAccordions>>>;
    breadcrumbs?: Maybe<Array<Maybe<Breadcrumbs>>>;
    discoverMore?: Maybe<DiscoverMore>;
    backToResultsLink?: Maybe<BackToResultsLink>;
};

export type PointOfInterest = {
    __typename?: 'PointOfInterest';
    title?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    distanceMiles?: Maybe<Scalars['Float']>;
    latitude?: Maybe<Scalars['Float']>;
    longitude?: Maybe<Scalars['Float']>;
    address?: Maybe<Scalars['String']>;
};

export type PriceDrop = {
    __typename?: 'PriceDrop';
    lastPriceChangeDate?: Maybe<Scalars['String']>;
    percentageChangeLabel?: Maybe<Scalars['String']>;
};

export type PriceHistory = {
    __typename?: 'PriceHistory';
    firstPublished?: Maybe<PriceHistoryFirstPublished>;
    lastSale?: Maybe<PriceHistoryLastSale>;
    priceChanges?: Maybe<Array<PriceHistoryChange>>;
};

export type PriceHistoryChange = {
    __typename?: 'PriceHistoryChange';
    isMinorChange: Scalars['Boolean'];
    isPriceDrop: Scalars['Boolean'];
    isPriceIncrease: Scalars['Boolean'];
    percentageChangeLabel: Scalars['String'];
    priceChangeDate: Scalars['String'];
    priceChangeLabel: Scalars['String'];
    priceLabel: Scalars['String'];
};

export type PriceHistoryFirstPublished = {
    __typename?: 'PriceHistoryFirstPublished';
    firstPublishedDate?: Maybe<Scalars['String']>;
    priceLabel?: Maybe<Scalars['String']>;
};

export type PriceHistoryLastSale = {
    __typename?: 'PriceHistoryLastSale';
    date: Scalars['String'];
    newBuild: Scalars['Boolean'];
    price: Scalars['Float'];
    priceLabel: Scalars['String'];
    recentlySold: Scalars['Boolean'];
};

export type PriceInfo = {
    __typename?: 'PriceInfo';
    internalValue: Scalars['Float'];
    rentFrequencyLabel?: Maybe<Scalars['String']>;
    unitsLabel?: Maybe<Scalars['String']>;
};

export type Properties = {
    __typename?: 'Properties';
    fullAddress?: Maybe<Scalars['String']>;
    propertyId: Scalars['Int'];
};

export type Property = {
    __typename?: 'Property';
    /**
     * Zoopla-internal property identifier.
     * Existing queries may return this, but in the future not every property will have one.
     * @deprecated Prefer uprn. Added to support migration to UPRN-first properties.
     */
    propertyId?: Maybe<Scalars['ID']>;
    /**
     * Universal Property Reference Number.
     * Public sector standard for referencing property information.
     * Nullable until we're fully migrated.
     * See https://en.wikipedia.org/wiki/Unique_Property_Reference_Number
     */
    uprn?: Maybe<Scalars['ID']>;
    details?: Maybe<PropertyDetails>;
    trackedProperty?: Maybe<TrackedProperty>;
    pointsOfInterest?: Maybe<Array<Maybe<PointOfInterest>>>;
    liveListings?: Maybe<Array<LiveListing>>;
    similarListings?: Maybe<Array<Maybe<Listing>>>;
};

export type PropertyTrackedPropertyArgs = {
    id: Scalars['String'];
};

export type PropertyLiveListingsArgs = {
    id: Scalars['String'];
};

export type PropertySimilarListingsArgs = {
    id: Scalars['String'];
};

export type PropertyCoordinates = {
    __typename?: 'PropertyCoordinates';
    latitude: Scalars['Float'];
    longitude: Scalars['Float'];
};

export type PropertyDetails = {
    __typename?: 'PropertyDetails';
    fullAddress: Scalars['String'];
    streetAddress: Scalars['String'];
    locality: Scalars['String'];
    postcode: Scalars['String'];
    countryId?: Maybe<Scalars['Int']>;
    outcode: Scalars['String'];
    postalArea: Scalars['String'];
    bathrooms?: Maybe<Scalars['Int']>;
    bedrooms?: Maybe<Scalars['Int']>;
    livingRooms?: Maybe<Scalars['Int']>;
    tags: Array<Scalars['String']>;
    coordinates?: Maybe<PropertyCoordinates>;
    estimate?: Maybe<Estimate>;
    history?: Maybe<History>;
};

export type PropertyIdMapping = {
    __typename?: 'PropertyIdMapping';
    propertyId?: Maybe<Scalars['String']>;
    uprn?: Maybe<Scalars['Int']>;
    udprn?: Maybe<Scalars['Int']>;
};

export enum PropertyTypeGroup {
    Flat = 'flat',
    House = 'house'
}

export type ProsAndConsDetails = {
    __typename?: 'ProsAndConsDetails';
    heading?: Maybe<Scalars['String']>;
    subHeading?: Maybe<Scalars['String']>;
    prosDescription?: Maybe<RichText>;
    consDescription?: Maybe<RichText>;
};

export enum PublicationStatus {
    Expired = 'Expired',
    Live = 'Live'
}

export type Query = {
    __typename?: 'Query';
    searchResults?: Maybe<Results>;
    searchResultsByParams?: Maybe<Results>;
    navbar?: Maybe<Navbar>;
    geoSuggestion?: Maybe<Array<Maybe<GeoSuggestion>>>;
    getSuggestedAddresses?: Maybe<AddressPostcodeSuggestion>;
    pointsOfInterest?: Maybe<Array<Maybe<PointOfInterest>>>;
    properties: Array<Properties>;
    addressesByPostcode?: Maybe<AddressesByPostcode>;
    userTrackedProperties?: Maybe<UserTrackedProperties>;
    seoAccordions?: Maybe<Array<Maybe<SeoAccordions>>>;
    breadcrumbs?: Maybe<Array<Maybe<Breadcrumbs>>>;
    discoverMore?: Maybe<DiscoverMore>;
    backToResultsLink?: Maybe<BackToResultsLink>;
    allNavBars?: Maybe<Array<Maybe<Navbar>>>;
    user?: Maybe<User>;
    favourites?: Maybe<Favourites>;
    emailAll?: Maybe<EmailAll>;
    abTests?: Maybe<Array<AbTest>>;
    redirects?: Maybe<Array<Maybe<Redirect>>>;
    newHomesDevelopmentData?: Maybe<NewHomesDevelopmentData>;
    articles?: Maybe<Articles>;
    articleCategories?: Maybe<ArticleCategories>;
    articleTag?: Maybe<ArticleTagResult>;
    author?: Maybe<AuthorResult>;
    authors?: Maybe<Authors>;
    meetTheTeam?: Maybe<MeetTheTeamResult>;
    govSchemes?: Maybe<GovSchemesData>;
    /**
     * A list of methods a user can use to login for a given email.
     * The user does not need to be logged in to call this query.
     */
    userLoginMethods?: Maybe<UserLoginMethodsResponse>;
    property?: Maybe<Property>;
    propertyIdMapping?: Maybe<PropertyIdMapping>;
    listing?: Maybe<ListingData>;
    listingPreview?: Maybe<Listing>;
    googleMapUrlSignatures?: Maybe<Array<Maybe<Scalars['String']>>>;
    valuationBranches: Array<ValuationBranch>;
    agentBranch?: Maybe<AgentBranch>;
    /** Fetches a user's saved properties. Requires a session cookie */
    savedProperties: SavedProperties;
    zooplaValuationToolData: ZooplaValuationToolData;
    /**
     * Echoes input given as a response
     * A simple query to test a new client, or the server without hitting a downstream datasource
     */
    echo: Scalars['String'];
};

export type QuerySearchResultsArgs = {
    path: Scalars['String'];
};

export type QuerySearchResultsByParamsArgs = {
    params: PathByParamFields;
};

export type QueryNavbarArgs = {
    id: Scalars['String'];
};

export type QueryGeoSuggestionArgs = {
    locationPrefix: Scalars['String'];
};

export type QueryGetSuggestedAddressesArgs = {
    address: Scalars['String'];
};

export type QueryPointsOfInterestArgs = {
    longitude: Scalars['Float'];
    latitude: Scalars['Float'];
};

export type QueryPropertiesArgs = {
    postcode: Scalars['String'];
};

export type QueryAddressesByPostcodeArgs = {
    postcode: Scalars['String'];
};

export type QuerySeoAccordionsArgs = {
    path: Scalars['String'];
};

export type QueryBreadcrumbsArgs = {
    path: Scalars['String'];
};

export type QueryDiscoverMoreArgs = {
    path: Scalars['String'];
};

export type QueryBackToResultsLinkArgs = {
    id: Scalars['Int'];
    searchIdentifier?: Maybe<Scalars['String']>;
    sessionId?: Maybe<Scalars['String']>;
};

export type QueryEmailAllArgs = {
    path: Scalars['String'];
};

export type QueryRedirectsArgs = {
    path: Scalars['String'];
};

export type QueryNewHomesDevelopmentDataArgs = {
    id: Scalars['Int'];
    deprecatedBranchId: Scalars['Int'];
};

export type QueryArticlesArgs = {
    category?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Int']>;
    skip?: Maybe<Scalars['Int']>;
    source?: Maybe<Scalars['String']>;
};

export type QueryArticleTagArgs = {
    slug: Scalars['String'];
};

export type QueryAuthorArgs = {
    slug: Scalars['String'];
};

export type QueryAuthorsArgs = {
    limit?: Maybe<Scalars['Int']>;
    skip?: Maybe<Scalars['Int']>;
};

export type QueryGovSchemesArgs = {
    slug: Scalars['String'];
};

export type QueryUserLoginMethodsArgs = {
    email: Scalars['String'];
};

export type QueryPropertyArgs = {
    id: Scalars['String'];
    uprn?: Maybe<Scalars['String']>;
};

export type QueryPropertyIdMappingArgs = {
    id: Scalars['String'];
};

export type QueryListingArgs = {
    id: Scalars['Int'];
};

export type QueryListingPreviewArgs = {
    id: Scalars['Int'];
};

export type QueryGoogleMapUrlSignaturesArgs = {
    urls: Array<Scalars['String']>;
};

export type QueryValuationBranchesArgs = {
    propertyId: Scalars['Int'];
    transactionType: TransactionType;
    v2Seed: Scalars['String'];
};

export type QueryAgentBranchArgs = {
    id: Scalars['Int'];
};

export type QuerySavedPropertiesArgs = {
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
    after?: Maybe<Scalars['ID']>;
    before?: Maybe<Scalars['ID']>;
};

export type QueryZooplaValuationToolDataArgs = {
    customerKey: Scalars['ID'];
};

export type QueryEchoArgs = {
    message: Scalars['String'];
};

export type Quote = IContentfulQuote & {
    __typename?: 'Quote';
    id: Scalars['ID'];
    description?: Maybe<Scalars['String']>;
    author?: Maybe<AuthorDetails>;
};

export type RecentSale = {
    __typename?: 'RecentSale';
    date?: Maybe<Scalars['String']>;
    price?: Maybe<Scalars['Int']>;
    propertyId?: Maybe<Scalars['Int']>;
    propertyTypeLabel?: Maybe<Scalars['String']>;
    streetAddress?: Maybe<Scalars['String']>;
    uri?: Maybe<Scalars['String']>;
};

export type Redirect = {
    __typename?: 'Redirect';
    code?: Maybe<Scalars['String']>;
    redirectUri?: Maybe<Scalars['String']>;
};

export type RegisterUserInput = {
    email: Scalars['String'];
    confirmEmail?: Maybe<Scalars['String']>;
    password: Scalars['String'];
    username?: Maybe<Scalars['String']>;
    contactName?: Maybe<Scalars['String']>;
    propertyStatus?: Maybe<Scalars['String']>;
    consents?: Maybe<Array<ConsentsInput>>;
};

export type RegisterUserPayload = {
    __typename?: 'RegisterUserPayload';
    success: Scalars['Boolean'];
    pageAfterLoginUrl?: Maybe<Scalars['String']>;
    errorMessage?: Maybe<Scalars['String']>;
    errorCode?: Maybe<Scalars['String']>;
    errorField?: Maybe<Scalars['String']>;
};

export type RentEstimate = {
    __typename?: 'RentEstimate';
    lowerPrice: Scalars['Int'];
    currentPrice: Scalars['Int'];
    upperPrice: Scalars['Int'];
};

export type ResponsiveImg = {
    __typename?: 'ResponsiveImg';
    width?: Maybe<Scalars['Int']>;
    src?: Maybe<Scalars['String']>;
};

export type Results = {
    __typename?: 'Results';
    analyticsTaxonomy?: Maybe<AnalyticsTaxonomy>;
    analyticsEcommerce?: Maybe<AnalyticsEcommerce>;
    pagination?: Maybe<Pagination>;
    metaInfo?: Maybe<Meta>;
    filters?: Maybe<Filters>;
    listings?: Maybe<Listings>;
    links?: Maybe<Links>;
    sortOrder?: Maybe<SortOrder>;
    seoBlurb?: Maybe<SeoBlurb>;
    title?: Maybe<Scalars['String']>;
    adTargeting?: Maybe<AdTargeting>;
    userAlertId?: Maybe<Scalars['String']>;
    savedSearchAndAlerts?: Maybe<SavedSearchAndAlerts>;
    polyenc?: Maybe<Scalars['String']>;
    polygon?: Maybe<Array<Maybe<Array<Maybe<Array<Maybe<Scalars['Float']>>>>>>>;
};

export type ResultsPolygonArgs = {
    path: Scalars['String'];
};

export type RichText = {
    __typename?: 'RichText';
    content?: Maybe<Scalars['JSON']>;
    nodeType: Scalars['String'];
    data?: Maybe<Scalars['JSON']>;
};

export type RichTextAndImage = {
    __typename?: 'RichTextAndImage';
    document: RichText;
    image: ContentfulImage;
};

export type RoomCount = {
    __typename?: 'RoomCount';
    numBathrooms?: Maybe<Scalars['Int']>;
    numBedrooms?: Maybe<Scalars['Int']>;
    numLivingRooms?: Maybe<Scalars['Int']>;
};

export type Row = {
    __typename?: 'Row';
    links?: Maybe<Array<Maybe<Link>>>;
};

export type SaleEstimate = {
    __typename?: 'SaleEstimate';
    lowerPrice: Scalars['Int'];
    currentPrice: Scalars['Int'];
    upperPrice: Scalars['Int'];
    confidenceLevel: ConfidenceLevel;
    valueChange?: Maybe<ValueChange>;
};

export type SavedListing = {
    __typename?: 'SavedListing';
    creationDate: Scalars['String'];
    listingStatus: ListingStatus;
    listing: ListingData;
};

export enum SavedListingUpdateErrorStatusCode {
    UserNotFound = 'user_not_found',
    ListingNotFound = 'listing_not_found',
    BadRequest = 'bad_request'
}

export type SavedListingUpdateInvalidInputError = {
    __typename?: 'SavedListingUpdateInvalidInputError';
    errorCode: SavedListingUpdateErrorStatusCode;
};

export type SavedListingUpdateResult =
    | SavedListingUpdateResultSuccess
    | SavedListingUpdateInvalidInputError;

export type SavedListingUpdateResultSuccess = {
    __typename?: 'SavedListingUpdateResultSuccess';
    successCode: SavedListingUpdateSuccessStatusCode;
};

export enum SavedListingUpdateSuccessStatusCode {
    Saved = 'saved',
    AlreadySaved = 'already_saved',
    Deleted = 'deleted'
}

export type SavedProperties =
    | SavedPropertyListResult
    | SavedPropertyListInvalidInputError;

export enum SavedPropertyListErrorStatusCode {
    UserNotFound = 'user_not_found',
    BadRequest = 'bad_request',
    InvalidPaginationParams = 'invalid_pagination_params',
    PaginationIdNotFound = 'pagination_id_not_found'
}

export type SavedPropertyListInvalidInputError = {
    __typename?: 'SavedPropertyListInvalidInputError';
    errorCode: SavedPropertyListErrorStatusCode;
};

export type SavedPropertyListResult = {
    __typename?: 'SavedPropertyListResult';
    listings?: Maybe<Array<SavedListing>>;
    listingIds?: Maybe<Array<Scalars['Int']>>;
    pageInfo: PageInfo;
};

export type SavedSearchAndAlerts = {
    __typename?: 'SavedSearchAndAlerts';
    currentFrequency?: Maybe<AlertFrequencyOption>;
    frequency?: Maybe<Array<Maybe<AlertFrequencyOption>>>;
    uri?: Maybe<Scalars['String']>;
};

export type SearchFields = {
    description?: Maybe<Scalars['String']>;
    userAlertId?: Maybe<Scalars['String']>;
    q?: Maybe<Scalars['String']>;
    section?: Maybe<Scalars['String']>;
    category?: Maybe<Scalars['String']>;
    priceFrequency?: Maybe<Scalars['String']>;
    includeSharedAccommodation?: Maybe<Scalars['String']>;
    keywords?: Maybe<Scalars['String']>;
    identifier?: Maybe<Scalars['String']>;
    radius?: Maybe<Scalars['String']>;
    added?: Maybe<Scalars['String']>;
    availableFrom?: Maybe<Scalars['String']>;
    priceMin?: Maybe<Scalars['String']>;
    priceMax?: Maybe<Scalars['String']>;
    bedsMin?: Maybe<Scalars['String']>;
    bedsMax?: Maybe<Scalars['String']>;
    rentalTerm?: Maybe<Scalars['String']>;
    petsAllowed?: Maybe<Scalars['String']>;
    billsIncluded?: Maybe<Scalars['String']>;
    includeSold?: Maybe<Scalars['String']>;
    includeRented?: Maybe<Scalars['String']>;
    furnishedState?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
    propertySubType?: Maybe<Array<Maybe<Scalars['String']>>>;
    feature?: Maybe<Array<Maybe<Scalars['String']>>>;
    includeRetirementHomes?: Maybe<Scalars['String']>;
    isRetirementHome?: Maybe<Scalars['String']>;
    includeSharedOwnership?: Maybe<Scalars['String']>;
    isSharedOwnership?: Maybe<Scalars['String']>;
    buyerIncentive?: Maybe<Scalars['String']>;
    newHomes?: Maybe<Scalars['String']>;
    isAuction?: Maybe<Scalars['String']>;
    chainFree?: Maybe<Scalars['String']>;
    reducedPriceOnly?: Maybe<Scalars['String']>;
    viewType?: Maybe<Scalars['String']>;
    polyenc?: Maybe<Scalars['String']>;
};

export type SecondarySearch = {
    __typename?: 'SecondarySearch';
    image?: Maybe<Scalars['String']>;
    heading?: Maybe<Scalars['String']>;
    searchLabel?: Maybe<Scalars['String']>;
    searchButtonText?: Maybe<Scalars['String']>;
    searchFilterType?: Maybe<Scalars['String']>;
};

export type SeoAccordions = {
    __typename?: 'SeoAccordions';
    category?: Maybe<Scalars['String']>;
    expanded?: Maybe<Scalars['Boolean']>;
    geo?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
    section?: Maybe<Scalars['String']>;
    transactionType?: Maybe<Scalars['String']>;
    rows?: Maybe<Array<Maybe<Row>>>;
    links?: Maybe<Array<Maybe<Link>>>;
};

export type SeoBlurb = {
    __typename?: 'SeoBlurb';
    areaLabel?: Maybe<Scalars['String']>;
    areaUri?: Maybe<Scalars['String']>;
    category?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
    transactionType?: Maybe<Scalars['String']>;
};

export type SeoSearchLinks = {
    __typename?: 'SeoSearchLinks';
    heading?: Maybe<Scalars['String']>;
    headerPanel?: Maybe<RichText>;
};

export type SigninUserInput = {
    password: Scalars['String'];
    email?: Maybe<Scalars['String']>;
    rememberMe?: Maybe<Scalars['Boolean']>;
};

export type SigninUserPayload = {
    __typename?: 'SigninUserPayload';
    success: Scalars['Boolean'];
    pageAfterLoginUrl?: Maybe<Scalars['String']>;
    errorMessage?: Maybe<Scalars['String']>;
    errorCode?: Maybe<Scalars['String']>;
    errorField?: Maybe<Scalars['String']>;
};

export type SimpleResponse = {
    __typename?: 'SimpleResponse';
    status?: Maybe<Scalars['Int']>;
    statusText?: Maybe<Scalars['String']>;
    body?: Maybe<Scalars['String']>;
};

export type SocialSignInFacebookResponse = {
    __typename?: 'SocialSignInFacebookResponse';
    success: Scalars['Boolean'];
};

export type SocialSignInGoogleOneTapResponse = {
    __typename?: 'SocialSignInGoogleOneTapResponse';
    success: Scalars['Int'];
};

export type SocialSignInGoogleResponse = {
    __typename?: 'SocialSignInGoogleResponse';
    success: Scalars['Boolean'];
};

export type SortOrder = {
    __typename?: 'SortOrder';
    currentSortOrder?: Maybe<Scalars['String']>;
    options?: Maybe<Array<Maybe<SortOrderOption>>>;
};

export type SortOrderOption = {
    __typename?: 'SortOrderOption';
    i18NLabelKey?: Maybe<Scalars['String']>;
    value?: Maybe<Scalars['String']>;
    selected?: Maybe<Scalars['Boolean']>;
};

export type SubImage = {
    __typename?: 'SubImage';
    small?: Maybe<Scalars['String']>;
    large?: Maybe<Scalars['String']>;
    caption?: Maybe<Scalars['String']>;
};

export type Subitem = {
    __typename?: 'Subitem';
    order?: Maybe<Scalars['Int']>;
    label?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    uri?: Maybe<Scalars['String']>;
    i18nLabelKey?: Maybe<Scalars['String']>;
    tracking?: Maybe<Scalars['String']>;
    datetime?: Maybe<Scalars['String']>;
    nofollow?: Maybe<Scalars['Boolean']>;
};

export type Subnav = {
    __typename?: 'Subnav';
    label?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    position?: Maybe<Scalars['Int']>;
    i18nLabelKey?: Maybe<Scalars['String']>;
    tracking?: Maybe<Scalars['String']>;
    subitems?: Maybe<Array<Maybe<Subitem>>>;
};

export type SuggestedAddresses = {
    __typename?: 'SuggestedAddresses';
    v?: Maybe<Scalars['String']>;
    i?: Maybe<Scalars['String']>;
};

export type Table = {
    __typename?: 'Table';
    heading: Scalars['String'];
    subHeading?: Maybe<Scalars['String']>;
    content: Array<Array<Scalars['String']>>;
};

export type Tag = {
    __typename?: 'Tag';
    content?: Maybe<Scalars['String']>;
};

export type Timeline = {
    __typename?: 'Timeline';
    currentStage?: Maybe<TimelineStage>;
    dates?: Maybe<TimelineDates>;
};

export type TimelineDates = {
    __typename?: 'TimelineDates';
    coming?: Maybe<Scalars['String']>;
    launched?: Maybe<Scalars['String']>;
    final?: Maybe<Scalars['String']>;
};

export enum TimelineStage {
    Coming = 'coming',
    Launched = 'launched',
    Final = 'final'
}

export type TrackedProperty = {
    __typename?: 'TrackedProperty';
    uprn?: Maybe<Scalars['String']>;
    isTracked?: Maybe<Scalars['Boolean']>;
    relationship?: Maybe<TrackedPropertyRelationship>;
};

export type TrackedPropertyInput = {
    uprn: Scalars['String'];
    propertyId: Scalars['String'];
    relationship?: Maybe<TrackedPropertyRelationship>;
};

export enum TrackedPropertyRelationship {
    Homeowner = 'HOMEOWNER',
    Landlord = 'LANDLORD',
    Tenant = 'TENANT',
    InterestedInBuying = 'INTERESTED_IN_BUYING',
    Interested = 'INTERESTED'
}

export enum TransactionType {
    Sale = 'SALE',
    Rent = 'RENT'
}

export type Transport = {
    __typename?: 'Transport';
    distanceInMiles?: Maybe<Scalars['Float']>;
    lat?: Maybe<Scalars['Float']>;
    lng?: Maybe<Scalars['Float']>;
    poiType?: Maybe<Scalars['String']>;
    title?: Maybe<Scalars['String']>;
    features?: Maybe<TransportFeatures>;
};

export type TransportFeatures = {
    __typename?: 'TransportFeatures';
    tubeLines?: Maybe<Scalars['String']>;
    zone?: Maybe<Scalars['String']>;
};

export enum TypeOfEnquiry {
    Sell = 'SELL',
    Let = 'LET',
    Curious = 'CURIOUS',
    Remortgage = 'REMORTGAGE'
}

export type UpdateUserConsentsInput = {
    consents: Array<UserConsentInput>;
};

export enum Urgency {
    ZeroToThreeMonths = 'ZERO_TO_THREE_MONTHS',
    ThreeToSixMonths = 'THREE_TO_SIX_MONTHS',
    MoreThanSixMonths = 'MORE_THAN_SIX_MONTHS'
}

export type User = {
    __typename?: 'User';
    name?: Maybe<Scalars['String']>;
    email?: Maybe<Scalars['String']>;
    phone?: Maybe<Scalars['String']>;
    loggedIn?: Maybe<Scalars['Boolean']>;
    status?: Maybe<Scalars['String']>;
    senderPropertyStatus?: Maybe<Scalars['String']>;
    userId?: Maybe<Scalars['Int']>;
    userUuid?: Maybe<Scalars['String']>;
    creationDate?: Maybe<Scalars['String']>;
    brandPrimary?: Maybe<Scalars['String']>;
    registrationSources?: Maybe<Array<Maybe<Scalars['String']>>>;
    registered?: Maybe<Scalars['Boolean']>;
    trackedProperties?: Maybe<UserTrackedProperties>;
};

export enum UserAboutMe {
    FirstTimeBuyer = 'first_time_buyer',
    LookingToRent = 'looking_to_rent',
    Other = 'other',
    BuyerNotFirstTime = 'buyer_not_first_time',
    CuriousHavingALook = 'curious_having_a_look',
    PropertyToSell = 'property_to_sell',
    OfferOnOwnProperty = 'offer_on_own_property',
    LookingToInvest = 'looking_to_invest',
    PropertyToLet = 'property_to_let',
    RecentlySold = 'recently_sold',
    Agent = 'agent'
}

export type UserAboutMeInput = {
    situation: UserAboutMe;
};

export type UserConsentInput = {
    id: Scalars['Int'];
    agreed: Scalars['Boolean'];
};

export enum UserLoginMethod {
    Zoopla = 'zoopla',
    Primelocation = 'primelocation',
    Smartnewhomes = 'smartnewhomes',
    Alltheagents = 'alltheagents',
    Homesoverseas = 'homesoverseas',
    Google = 'google',
    Facebook = 'facebook'
}

export type UserLoginMethodsResponse = {
    __typename?: 'UserLoginMethodsResponse';
    /** The email address the login methods are for. */
    email: Scalars['String'];
    /** Whether or not the user has registered. */
    registered: Scalars['Boolean'];
    /**
     * The list consists of methods a user can use to login.
     * If a user registered directly then the primary
     * brand is given such as zoopla as well as any social
     * login methods such as facebook or google.
     */
    loginMethods: Array<UserLoginMethod>;
};

export type UserTrackedProperties = {
    __typename?: 'UserTrackedProperties';
    total: Scalars['Int'];
    properties: Array<Property>;
};

export type ValuationBranch = {
    __typename?: 'ValuationBranch';
    area?: Maybe<Scalars['String']>;
    averageRentPrice?: Maybe<Scalars['Int']>;
    averageSalePrice?: Maybe<Scalars['Int']>;
    branchDisplayName?: Maybe<Scalars['String']>;
    branchId: Scalars['Int'];
    hasAppraisalBooster?: Maybe<Scalars['Boolean']>;
    logo?: Maybe<Scalars['String']>;
    numberOfRentListings?: Maybe<Scalars['Int']>;
    numberOfSaleListings?: Maybe<Scalars['Int']>;
    outcode?: Maybe<Scalars['String']>;
    selected?: Maybe<Scalars['Boolean']>;
    featuredTag?: Maybe<Scalars['String']>;
    address?: Maybe<Scalars['String']>;
    postcode?: Maybe<Scalars['String']>;
};

export type ValuationLeadInput = {
    branchIds: Array<Scalars['Int']>;
    contactPreference?: Maybe<ContactPreference>;
    contactTimePreference?: Maybe<ContactTimePreference>;
    email: Scalars['String'];
    message?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    phone: Scalars['String'];
    propertyId: Scalars['Int'];
    transactionType: TransactionType;
    typeOfEnquiry: TypeOfEnquiry;
    urgency?: Maybe<Urgency>;
    url: Scalars['String'];
    userId?: Maybe<Scalars['Int']>;
    v2Seed: Scalars['String'];
};

export type ValuationLeadResponse = {
    __typename?: 'ValuationLeadResponse';
    valuationBranches?: Maybe<Array<ValuationBranch>>;
    uniqueLeadIdentifier: Scalars['String'];
};

export type ValueChange = {
    __typename?: 'ValueChange';
    percentageChange: Scalars['Float'];
    saleDate: Scalars['String'];
    numericChange: Scalars['Int'];
};

export type ViewCount = {
    __typename?: 'ViewCount';
    viewCount30day?: Maybe<Scalars['Int']>;
};

export type ZooplaValuationToolData = {
    __typename?: 'ZooplaValuationToolData';
    customerKey: Scalars['ID'];
    agencyName?: Maybe<Scalars['String']>;
    email?: Maybe<Scalars['String']>;
    logoBaseUrl?: Maybe<Scalars['String']>;
    logoFileName?: Maybe<Scalars['String']>;
    numberOfBedrooms?: Maybe<Array<Maybe<ZvtKeyValue>>>;
    primaryColorHex?: Maybe<Scalars['String']>;
    valuationTypes?: Maybe<Array<Maybe<ZvtKeyValue>>>;
    whenToSell?: Maybe<Array<Maybe<ZvtKeyValue>>>;
};

export type ZvtFormSubmissionValuationInput = {
    propertyId?: Maybe<Scalars['Int']>;
    recaptchaToken?: Maybe<Scalars['String']>;
    accountIdentifier?: Maybe<Scalars['ID']>;
    firstname?: Maybe<Scalars['String']>;
    lastname?: Maybe<Scalars['String']>;
    email?: Maybe<Scalars['String']>;
    phone?: Maybe<Scalars['String']>;
    info?: Maybe<Scalars['String']>;
    numberOfBedrooms?: Maybe<ZvtNumberOfBedrooms>;
    valuationType?: Maybe<ZvtValuationType>;
    whenToSell?: Maybe<ZvtWhenToSell>;
    isAdReachExpressLead?: Maybe<Scalars['Boolean']>;
};

export type ZvtFormSubmissionValuationResponse = {
    __typename?: 'ZVTFormSubmissionValuationResponse';
    ok: Scalars['Boolean'];
};

export type ZvtKeyValue = {
    __typename?: 'ZVTKeyValue';
    key: Scalars['String'];
    value?: Maybe<Scalars['Int']>;
};

export enum ZvtNumberOfBedrooms {
    One = 'ONE',
    Two = 'TWO',
    Three = 'THREE',
    Four = 'FOUR',
    Five = 'FIVE',
    SixPlus = 'SIX_PLUS'
}

export type ZvtValidateEmailInput = {
    email?: Maybe<Scalars['String']>;
};

export type ZvtValidateEmailResponse = {
    __typename?: 'ZVTValidateEmailResponse';
    valid?: Maybe<Scalars['Boolean']>;
};

export enum ZvtValuationType {
    SalesAndLettings = 'SALES_AND_LETTINGS',
    Sales = 'SALES',
    Lettings = 'LETTINGS'
}

export enum ZvtWhenToSell {
    Within_3Months = 'WITHIN_3_MONTHS',
    Within_6Months = 'WITHIN_6_MONTHS',
    Within_12Months = 'WITHIN_12_MONTHS',
    JustCurious = 'JUST_CURIOUS'
}
